import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar, MatSnackBarVerticalPosition, MatSnackBarHorizontalPosition } from '@angular/material/snack-bar';
import { environment } from '@env';
import { AppComponent } from '@app/app.component';
import * as dayjs from 'dayjs';

@Injectable()
export class UtilService {

	constructor(
		private router: Router,
		private snackBar: MatSnackBar
	) { }

	appComponent: AppComponent;

	reload(prevUrl?) {
		this.appComponent.ngOnInit();
		const router = this.router;
		if (!prevUrl) {
			prevUrl = this.router.url;
		}
		this.router.navigateByUrl('/').then(function() {
			router.navigateByUrl(prevUrl);
		});
	}

	removeInvalidClasses() {
		setTimeout(() => {
			Array.from(document.querySelectorAll('mat-form-field')).forEach((formField) => {
				if (formField.className.includes('mat-form-field-invalid')) {
					formField.className = formField.className.replace('mat-form-field-invalid', '');
				}
			});
		}, 300);
	}

	/**
	 * Función que devuelve el padre más cercano filtrando por selector
	 * @param element Selector base
	 * @param parent Selector padre al que sea desea llegar
	 */
	parents(element: string | any, parent: string) {
		let el: any = typeof element === 'string' ? document.querySelector(element) : element;
		const parents = Array.from(document.querySelectorAll(parent));
		while (el.tagName !== 'HTML') {
			el = el.parentNode;
			if (parents.indexOf(el) !== -1) {
				return el;
			}
		}
		return null;
	}

	bloquearScroll(opened: boolean) {
		document.querySelector('html').setAttribute('style', opened ? 'hidden' : 'auto');
		if (opened) {
			this.smoothScroll();
		}
	}

	smoothScroll() {
		const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
		if (currentScroll > 0) {
			window.requestAnimationFrame(this.smoothScroll);
			window.scrollTo(0, currentScroll - (currentScroll / 5));
		}
	}

	notification(message: string, action?: string, duration?: number, verticalPosition?: MatSnackBarVerticalPosition, horizontalPosition?: MatSnackBarHorizontalPosition) {
		if (!action) {
			action = 'Cerrar';
		}
		if (!duration) {
			duration = 5;
		}
		if (!verticalPosition) {
			verticalPosition = 'bottom';
		}
		if (!horizontalPosition) {
			horizontalPosition = 'start';
		}
	    return this.snackBar.open(message, action, {
	      duration: duration * 1000,
		  panelClass: 'snack',
		  verticalPosition,
		  horizontalPosition
    	});
    }

	monthName(month, format?: string) {
		const fecha = dayjs().set('month', month);
		let mes: string;
		if (format) {
			mes = fecha.format(format);
		} else {
			mes = fecha.format('MMMM');
		}
		return mes.substring(0, 1).toUpperCase() + mes.substr(1);
	}

	/**
	 *  Getter de localStorage
	 *  @param nombreVariable - Nombre de la variable
	 *  @param decodificar - true : json, false: string
	**/
	getLS(nombreVariable: string, decodificar?: boolean): any {
		let resultado = localStorage.getItem(nombreVariable);
		if (decodificar) {
			try {
				resultado = JSON.parse(resultado);
			} catch (e) {
				resultado = null;
			}
		}
		if (!resultado) {
			resultado = '';
		}
		return resultado;
	}

	/**
	 *  Setter de localStorage
	 *  @param nombreVariable - Nombre de la variable
	 *  @param enJson - true : json, false: string
	 *  @param valor - Valor a guardar
	**/
	setLS(nombreVariable: string, valor: any, enJson?: boolean) {
		if (enJson) {
			valor = JSON.stringify(valor);
		}
		localStorage.setItem(nombreVariable, valor);
		return valor;
	}

	/**
	 *  Getter de parametros de configuración vía localStorage
	 *  @param nombreParametro - Nombre del parametro guardado en localStorage
	 *  @param nombreVariable - Nombre de la variable
	**/
	getConfigLS(parametro:string, nombreVariable: string): any {
		const config = this.getLS(parametro,true);
		return config[nombreVariable] || null;
	}
	/**
	 *  Setter de parametros de configuración vía localStorage
	 *  @param nombreParametro - Nombre del parametro guardado en localStorage
	 *  @param nombreVariable - Nombre de la variable
	 *  @param valor - Valor a guardar
	**/
	setConfigLS(parametro:string, nombreVariable: string, valor: any) {
		let config = this.getLS(parametro,true);
		if (!config) {
			config = {};
		}
		config[nombreVariable] = valor;
		return this.setLS(parametro,config,true);
	}


	loseFocus() {
		setTimeout(() => {
			const el: any = document.querySelector(':focus');
			el.blur();
		}, 0);
	}

	haySubtablas() {
		return (document.querySelectorAll('.subtabla').length > 0) && !(Array.from(document.querySelectorAll('.subtabla')).filter(function () { return getComputedStyle(this.parentNode).display == 'flex'; }).length == 0);
	}

	abrirUrl(url) {
		console.log('abro', url);
		window.open(environment[environment.alias[window.location.hostname]].baseUrl + url, '_blank');
	}

	tieneClase(elem, clase) {
		return document.querySelector(elem).className.includes(clase);
	}

	getFirstValue(values) {
		return values.find(this.valeDistintoDeNada);
	}

	valeDistintoDeNada = function (o) {
		return (typeof (o) !== 'undefined' && o !== null && o != "" && o != false && o !=0 ) || null;
	};

	copyClipboard(text: string) {
		const listener = (e: ClipboardEvent) => {
			const clipboard = e.clipboardData || window['clipboardData'];
			clipboard.setData('text', text);
			e.preventDefault();
		};

		document.addEventListener('copy', listener, false);
		document.execCommand('copy');
		document.removeEventListener('copy', listener, false);

		this.notification('Copied to clipboard', '', 0, 'bottom', 'center');
	}

}
